import React, { Component } from "react";
import Images from "../Images";
import SlotsCourasel from "./SlotsCourasel";
import SpecialGame from "./SpecialGame";
import TopGames from "./TopGames";
import NewGames from "./NewGames";
import { connect } from "react-redux";
import { AppConfig } from "../../../helpers";
import { Col, Row } from "antd";
import SlotGame from "./SlotGame";

export class SlotsMainSection extends Component {
  render() {
    const {
      slotsGames,
      slotsFrontPageTemplates,
      slotsGamesCategories,
      categoryId,
      gameGroup,
      updateCategory,
      history,
      topGamesInfoType,
      match
    } = this.props;
    // row 3 col1
    const row3Col1 =
      slotsFrontPageTemplates &&
      slotsFrontPageTemplates.filter((item) => {
        return item.rowId == 3 && item.columId == 1;
      });
    const row3Col1Categories =
      row3Col1 &&
      row3Col1.length > 0 &&
      slotsGamesCategories &&
      slotsGamesCategories
        .filter((game) => game.categoryId == row3Col1[0].categoryId);
    const row3Col1Games= row3Col1Categories && row3Col1Categories.length > 0 && row3Col1Categories[0].slotsGames && row3Col1Categories[0].slotsGames.sort((a, b) => a.gameOrder < b.gameOrder)
    const row1Col2ImageType = row3Col1 && row3Col1.length > 0 && row3Col1[0].imageTypeId
    const row3Col1Info =
      slotsGamesCategories &&
      row3Col1 &&
      row3Col1.length > 0 &&
      slotsGamesCategories.filter(
        (category) => category.categoryId == row3Col1[0].categoryId
      );

    //
    // row 4 col1
    const row4Col1 =
      slotsFrontPageTemplates &&
      slotsFrontPageTemplates.filter((item) => {
        return item.rowId == 4 && item.columId == 1;
      });
    const row4Col1Categories =
      row4Col1 &&
      row4Col1.length > 0 &&
      slotsGamesCategories &&
      slotsGamesCategories
        .filter((game) => game.categoryId == row4Col1[0].categoryId);
    const row4Col1Games= row4Col1Categories && row4Col1Categories.length > 0 && row4Col1Categories[0].slotsGames && row4Col1Categories[0].slotsGames.sort((a, b) => a.gameOrder < b.gameOrder)
    const row4Col1ImageType = row4Col1 && row4Col1.length > 0 && row4Col1[0].imageTypeId
    const row4Col1Info =
      slotsGamesCategories &&
      row4Col1 &&
      row4Col1.length > 0 &&
      slotsGamesCategories.filter(
        (category) => category.categoryId == row4Col1[0].categoryId
      );

    //
    // row 5 col1
    const row5Col1 =
      slotsFrontPageTemplates &&
      slotsFrontPageTemplates.filter((item) => {
        return item.rowId == 5 && item.columId == 1;
      });
    const row5Col1Games =
      row5Col1 &&
      row5Col1.length > 0 &&
      slotsGames &&
      slotsGames
        .filter((game) => game.categoryId == row5Col1[0].categoryId)
        .sort((a, b) => a.gameOrder < b.gameOrder);
    //
    // row 6 col1
    const row6Col1 =
      slotsFrontPageTemplates &&
      slotsFrontPageTemplates.filter((item) => {
        return item.rowId == 6 && item.columId == 1;
      });
    const row6Col1Categories =
      row6Col1 &&
      row6Col1.length > 0 &&
      slotsGamesCategories &&
      slotsGamesCategories
        .filter((game) => game.categoryId == row6Col1[0].categoryId);
    const row6Col1Games= row6Col1Categories && row6Col1Categories.length > 0 &&  row6Col1Categories[0].slotsGames && row6Col1Categories[0].slotsGames.sort((a, b) => a.gameOrder < b.gameOrder)
    const row6Col1ImageType = row6Col1 && row6Col1.length > 0 && row6Col1[0].imageTypeId
    const row6Col1Info =
      slotsGamesCategories &&
      row6Col1 &&
      row6Col1.length > 0 &&
      slotsGamesCategories.filter(
        (category) => category.categoryId == row6Col1[0].categoryId
      );

    //
    // row 3 col2
    const row3Col2 =
      slotsFrontPageTemplates &&
      slotsFrontPageTemplates.filter((item) => {
        return item.rowId == 3 && item.columId == 2;
      });
    const row3Col2Categories =
      row3Col2 &&
      row3Col2.length > 0 &&
      slotsGamesCategories &&
      slotsGamesCategories
        .filter((game) => game.categoryId == row3Col2[0].categoryId);
    const row3Col2Games= row3Col2Categories && row3Col2Categories.length > 0 && row3Col2Categories[0].slotsGames && row3Col2Categories[0].slotsGames.sort((a, b) => a.gameOrder < b.gameOrder)
    const row3Col2ImageType = row3Col2 && row3Col2.length > 0 && row3Col2[0].imageTypeId
    const row3Col2Info =
    slotsGamesCategories &&
    row3Col2 &&
    row3Col2.length > 0 &&
    slotsGamesCategories.filter(
      (category) => category.categoryId == row3Col2[0].categoryId
    );
    //
    // row 5 col2
    const row5Col2 =
      slotsFrontPageTemplates &&
      slotsFrontPageTemplates.filter((item) => {
        return item.rowId == 5 && item.columId == 2;
      });
    const row5Col2Categories =
      row5Col2 &&
      row5Col2.length > 0 &&
      slotsGamesCategories &&
      slotsGamesCategories
        .filter((game) => game.categoryId == row5Col2[0].categoryId);
    const row5Col2Games= row5Col2Categories && row5Col2Categories.length > 0 && row5Col2Categories[0].slotsGames && row5Col2Categories[0].slotsGames.sort((a, b) => a.gameOrder < b.gameOrder)
    const row5Col2ImageType = row5Col2 && row5Col2.length > 0 && row5Col2[0].imageTypeId
    
      // row 7 col1
      const row7Col1 =
      slotsFrontPageTemplates &&
      slotsFrontPageTemplates.filter((item) => {
        return item.rowId == 7 && item.columId == 1;
      });
    const row7Col1Categories =
      row7Col1 &&
      row7Col1.length > 0 &&
      slotsGamesCategories &&
      slotsGamesCategories
        .filter((game) => game.categoryId == row7Col1[0].categoryId);

    const row7Col1Games= row7Col1Categories && row7Col1Categories.length > 0 &&  row7Col1Categories[0].slotsGames && row7Col1Categories[0].slotsGames.sort((a, b) => a.gameOrder < b.gameOrder)
    const row7Col1ImageType = row7Col1 && row7Col1.length > 0 && row7Col1[0].imageTypeId
    const row7Col1Info =
      slotsGamesCategories &&
      row7Col1 &&
      row7Col1.length > 0 &&
      slotsGamesCategories.filter(
        (category) => category.categoryId == row7Col1[0].categoryId
      );

    //


    // special game (jackpot)
    const specialGameInfo =
      slotsFrontPageTemplates &&
      slotsFrontPageTemplates.filter((item) => {
        return item.rowId == 5 && item.jackpotGameId;
      });
    const specialGame =
      specialGameInfo &&
      specialGameInfo.length > 0 &&
      slotsGames &&
      slotsGames.filter(
        (game) => game.gameId == specialGameInfo[0].jackpotGameId
      );

    //
    return (
      <div className="slots-main-section">
        <div className="left-sider">
          {" "}
          {match.params.categoryId == 0 ? (
            <>
              <SlotsCourasel
                title={row3Col1Info && row3Col1Info[0].categoryName}
                autoPlay={false}
                slides={row3Col1Games}
                slidesToShow={(row3Col1 && row3Col1.length > 0 && row3Col1[0].displayGames) ? ( row3Col1[0].displayGames) : 5}
                history={history}
                type={"images"}
                updateCategory={updateCategory}
                categoryId={row3Col1Info && row3Col1Info[0].categoryId}
                imageSpecialTypeId={row3Col1 && row3Col1.length > 0 && row3Col1[0].imageSpecialTypeId}
                largeSlideNumber={row3Col1 && row3Col1.length > 0 && row3Col1[0].imageSpecialSizeOrder}
                imageType={row1Col2ImageType}
              />
              <SlotsCourasel
                title={row4Col1Info && row4Col1Info[0].categoryName}
                autoPlay={false}
                slides={row4Col1Games}
                slidesToShow={(row4Col1 && row4Col1.length> 0 && row4Col1[0].displayGames) ? ( row4Col1[0].displayGames) : 5}
                history={history}
                type={"images"}
                updateCategory={updateCategory}
                categoryId={row4Col1Info && row4Col1Info[0].categoryId}
                imageSpecialTypeId={row4Col1 && row4Col1.length > 0 && row4Col1[0].imageSpecialTypeId}
                largeSlideNumber={row4Col1 && row4Col1.length > 0 && row4Col1[0].imageSpecialSizeOrder}
                imageType={row4Col1ImageType}
              />
              {specialGame && specialGame.length > 0 && <SpecialGame specialGame={specialGame} history={history} />}
              <SlotsCourasel
                title={row6Col1Info && row6Col1Info[0].categoryName}
                autoPlay={false}
                slides={row6Col1Games}
                history={history}
                slidesToShow={(row6Col1 && row6Col1.length > 0 && row6Col1[0].displayGames) ? ( row6Col1[0].displayGames) : 4}
                type={"images"}
                updateCategory={updateCategory}
                categoryId={row6Col1Info && row6Col1Info[0].categoryId}
                imageSpecialTypeId={row6Col1 && row6Col1.length > 0 && row6Col1[0].imageSpecialTypeId}
                largeSlideNumber={row6Col1 && row6Col1.length> 0 && row6Col1[0].imageSpecialSizeOrder}
                imageType={row6Col1ImageType}
              />
              <SlotsCourasel
                  title={row7Col1Info && row7Col1Info[0].categoryName}
                  autoPlay={false}
                  slides={row7Col1Games}
                  history={history}
                  slidesToShow={(row7Col1 && row7Col1.length > 0 && row7Col1[0].displayGames) ? (row7Col1[0].displayGames) : 5}
                  type={"images"}
                  updateCategory={updateCategory}
                  categoryId={row7Col1Info && row7Col1Info[0].categoryId}
                  imageType={row7Col1ImageType}
                  imageSpecialTypeId={row7Col1 && row7Col1.length > 0 && row7Col1[0].imageSpecialTypeId}
                  largeSlideNumber={row7Col1 && row7Col1.length > 0 && row7Col1[0].imageSpecialSizeOrder}
                />
            </>
          ) : (
            <div className="slot-game-group">
              <Row
                gutter={{
                  xs: 16,
                  sm: 16,
                  md: 16,
                  lg: 24,
                }}
                type="flex"
                // align='stretch'
              >
                {gameGroup.map((game) => (
                  <Col
                    className="gutter-row"
                    md={6}
                    xs={24}
                    sm={12}
                    key={game.gameId}
                  >
                    <SlotGame
                      history={history}
                      gameId={game.gameId}
                      style={{ width: "100%" }}
                      src={`${AppConfig.icons}${game.platformGameName}/${game.platformGameName}_m.webp`}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          )}
        </div>
        <div className="right-sider" style={match.params.categoryId != 0 ? {justifyContent:"unset"} : {}}>
          <TopGames games={row3Col2Games} history={history} topGamesInfoType={row3Col2ImageType} title={row3Col2Info && row3Col2Info[0].categoryName}/>
          <NewGames slides={row5Col2Games} history={history} newImagesType={row5Col2ImageType} row5Col2Categories={row5Col2Categories}/>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (_, initialProps) => (state) => {
  return {
    slotsGames: state.slots.slotsGames,
    slotsFrontPageTemplates: state.slots.slotsFrontPageTemplates,
    slotsGamesCategories: state.slots.slotsGamesCategories,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SlotsMainSection);
